module.exports = __webpack_public_path__ + "assets/img/tracked-box1-icon1.a6b91fbd.svg";